import * as React from 'react';
import clsx from 'clsx';
import { Select as SelectAntd, SelectProps } from 'antd';
import formStyles from '../../../shared/Form.module.scss';
import type { FieldWrapperProps } from '../../../shared/interface';
import styles from '../Select.module.scss';

export interface Props extends SelectProps, FieldWrapperProps {
  menuTitle?: string;
}

type UseMultiSelectElement = (props: Props) => [React.ReactElement];
export const useMultiSelectElement: UseMultiSelectElement = (selectProps) => {
  const { menuTitle, ...rest } = selectProps;

  const dropdownRender = (menu) => (
    <>
      {menuTitle && <div className={styles.menuHeader}>{menuTitle}</div>}
      {menu}
    </>
  );

  const el = (
    <SelectAntd {...rest} mode="multiple" dropdownRender={dropdownRender} />
  );
  return [el];
};

const MultiSelectAntd: React.FC<Props> = (props) => {
  const { label, fieldClassName, trailer, info } = props;

  const [element] = useMultiSelectElement(props);

  return (
    <div
      className={clsx(formStyles.field, styles.selectContainer, fieldClassName)}
    >
      {label && <label className={formStyles.label}>{label}</label>}
      <div className={formStyles.control}>{element}</div>
      {trailer}
      {info && <div className={styles.info}>{info}</div>}
    </div>
  );
};

export default MultiSelectAntd;
